import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelectedClient } from '../../hooks/useSelectedClient';
import SendCertificateDialog from './components/SendCertificateDialog';
import { useDashboardData } from '../dashboard/hooks/useDashboardData';
import { useMasterCertificates } from '../master-certificate/hooks/useMasterCertificates';
import type { Certificate, CertificateStatus } from '../dashboard/types/dashboard';

export default function SendCertificatePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasSelectedClient, insuredId } = useSelectedClient();

  const coiRequestData = location.state?.coiRequestData;
  const initialMasterCertId: string | undefined = location.state?.initialMasterCertId;

  const { data } = useDashboardData({ enabled: !!hasSelectedClient });

  // Master Certificates logic
  const {
    certificates: masterCertificates = [],
    isLoading: masterCertsLoading,
  } = useMasterCertificates(insuredId);

  // Map MasterCertificate to Certificate for UI
  const mapMasterToCertificate = (mc: any): Certificate => ({
    id: mc.databaseId,
    title: mc.name,
    lineOfBusiness: mc.policies && mc.policies.length > 0 ? mc.policies[0].linesOfBusiness?.[0] || '' : '',
    certificateNumber: mc.databaseId,
    issuedDateLabel: mc.createDate ? new Date(mc.createDate).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }) : '',
    status: mc.active ? ('Active' as CertificateStatus) : ('Expired' as CertificateStatus),
    icon: 'pi pi-file',
  });
  const mappedCertificates = React.useMemo(() => masterCertificates.map(mapMasterToCertificate), [masterCertificates]);

  return (
    <SendCertificateDialog
      onBack={() => navigate('/dashboard')}
      certificates={mappedCertificates}
      rawMasterCertificates={masterCertificates}
      masterCertsLoading={masterCertsLoading}
      syncedPolicies={data?.linkedPolicies}
      insuredDatabaseId={insuredId}
      insuredEmail={data?.client?.email}
      initialEmail={coiRequestData?.insuredEmail || ""}
      initialContactName={coiRequestData?.holderName || ""}
      initialCompanyName={coiRequestData?.insuredName || ""}
      initialMasterCertId={initialMasterCertId}
    />
  );
}